import React, { Fragment } from 'react';

import { Grid } from '@mui/material';
import useTransformStore from '../../useTransformStore';
import ChipInput from '../../../ChipInput/ChipInput';

function ConvertListToText({ availablePlaceholders, onPlaceholderSelected, listBelow, index }) {
  return (
    <Fragment>
      <Grid item xs={12} className="item-label">
        Convert this list to text
      </Grid>
      <Grid item xs={12} className="input-list-transform">
        <ChipInput
          placeholders={availablePlaceholders}
          onPlaceholderSelected={onPlaceholderSelected}
          fullWidth
          onBeforeAdd={chip => {
            useTransformStore.getState().setComponent(chip, index, 'listBelow');
            return true;
          }}
          placeholder="Insert a list "
          inputValue={listBelow}
          onDelete={indexChip => useTransformStore.getState().deleteChip(indexChip, index, 'listBelow')}
          onFocus={() => useTransformStore.getState().setFocus(index, 'listBelow')}
        />
      </Grid>
    </Fragment>
  );
}

export default ConvertListToText;
